export default [
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `...`,
        choicesBtns: `unset`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `...`,
        characterImg: `assets/chars/anna/annoyedCasual.webp`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/anna/closedEyesBlushCasual.webp`,
        speakerTxt: `Wait, she is leaning in for a kiss!`,
        speakerTxtRS: `Čekaj, ona se približava za poljubac!`,
        dialogFx: `assets/dialog/joseph/joseph0106.mp3`,
    },
    {
        speakerTxt: `My heart is pounding like a drum, and I can hardly believe this is happening. She is so close, and I'm so eager to feel your lips on mine.`,
        speakerTxtRS: `Srce mi lupa kao bubanj, i jedva mogu da verujem da se ovo dešava. Ona je tako blizu, i tako sam nestrpljiv da osetim tvoje usne na svojima.`,
        dialogFx: `assets/dialog/joseph/joseph0107.mp3`
    }
]